module.exports = __webpack_public_path__ + "static/media/united-states-of-america.36ab476e.svg";